export default "__VITE_ASSET__CiCKx1TE__"